// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"storyliner-K8ko3T","nameContainer":"storyliner-lSIsQF","imageContainer":"storyliner-jS8HMG","heading":"storyliner-AMaodO","card":"storyliner-2CMZRN"};